export const locale = {
  lang: 'de',
  data: {
    'ALERTS':{
      'OK':'OK'
    },
    'FOCUS':{
      'GRUPOS':{
        'ADMIN': 'Gruppenmanager',
        'CREAR': 'Gruppe erstellen',
        'EDITAR': 'Gruppe bearbeiten',
        'APLICAR': 'Anwenden',
        'NAME': 'Gruppenname',
        'DESCRIPCION': 'Beschreibung',
        'FILTROS': 'Filter',
        'ACCION': 'Aktionen',
        'EDIT': 'Bearbeiten',
        'DELETE': 'Löschen'
      },
      'CREAR': {
        'DATO': 'Gruppendaten',
        'NAME': 'Gruppenname',
        'DESCRIPCION': 'Gruppenbeschreibung',
        'FILTROS': 'Filter',
        'FILSELEC': 'Ausgewählte Filter',
        'COUNTRY': 'Land',
        'CARGO': 'Position oder Funktion',
        'ANTIG': 'Altertum',
        'GENDER': 'Geschlecht'
      },
      'REACTIVOS': {
        'SIN': 'Sie haben die Auswahl der Anweisungen noch nicht durchgeführt',
        'STEPS': {
          '1': {
              'TITULO': 'Auswahl der Anweisungen',
              'DISPONIBLES': 'Verfügbare Vorlagen: ',
              'LISTADO': {
                'TITULO': 'Wählen Sie die Aussagen für eine Liste aus, für die die Umfrage erstellt werden soll',
                'SUBTITULO': 'Wählen Sie eine Vorlage aus der Liste, um deren Aussagenliste anzuzeigen',
                'PICKEDTITU': 'Anweisungsliste für Vorlage: ',
                'PICKEDTOT': 'Verfügbare Anweisungen: ',
                'PICKEDNUM': 'Ausgewählte Anweisungen: ',
              }
          },
          '2': {
              'TITULO': 'Übersetzungen'
          },
          '3': {
              'TITULO': 'Previsualización',
              'TEXTOS': {
                'es': {
                  'EMPRESA': 'Responde pensando en tu empresa y en todos los líderes',
                  'AREA': 'Responde pensando en tu área de trabajo y tu líder directo',
                  'BOTONES': {
                    '0': 'Casi siempre es falso',
                    '1': 'Frecuentemente es falso',
                    '2': 'A veces es falso / A veces es verdad',
                    '3': 'Frecuentemente es verdad',
                    '4': 'Casi siempre es verdad'
                  }
                },
                'en': {
                  'EMPRESA': 'Organisationsperspektive',
                  'AREA': 'Arbeitsgruppen-Perspektive',
                  'BOTONES': {
                    '0': 'Es ist fast immer falsch',
                    '1': 'Es ist oft falsch',
                    '2': 'Manchmal ist es falsch / Manchmal ist es wahr',
                    '3': 'Es ist oft wahr',
                    '4': 'Es ist fast immer wahr'
                  }
                },
                'pt': {
                  'EMPRESA': 'Perspectiva da organização',
                  'AREA': 'Perspectiva do grupo de trabalho',
                  'BOTONES': {
                    '0': 'Quase sempre é falso',
                    '1': 'É frequentemente falso',
                    '2': 'Às vezes é falso / às vezes é verdade',
                    '3': 'É frequentemente verdade',
                    '4': 'Quase sempre é verdade'
                  }
                },
              }
            }
        }
      }
    },
    'CERTIFICAR': {
          'TITUTEST': 'ASDGF',
          'IDIOMAS': {
            'ELEGIR': 'Choose',
            'STATUS': {
              'PEND': 'Schritt abgeschlossen',
              'DONE': 'Schritt abgeschlossen',
              'LOCK':'Schritt wieder öffnen',
              'UNLOCK':'Schritt in Bearbeitung'
            },
            'MENSAJES':{
              'ADDLANG': 'Sie haben gewählt',
              'NOADITIONAL': 'Sie haben sich entschieden, keine zusätzlichen Sprachen einzustellen',
              'ERRORADD': 'Bei der Auswahl der Sprache ist ein Fehler aufgetreten',
              'LANGDEL': 'Sie haben ',
              'NOADITIONALDEL': 'Sie haben die Option, keine zusätzlichen Sprachen einzustellen, zurückgenommen',
              'ERRORDEL': 'Beim Entfernen der Sprache ist ein Fehler aufgetreten ',
              'MAINPICKED': 'Sie haben bereits die Hauptumfragesprache ausgewählt.<br><br>Um sie zu ändern, entfernen Sie die ausgewählte Sprache und wählen Sie eine neue.'
            },
            'CARD1': {
              'TITULO': 'Hauptsprache',
              'ACCION': {
                'PRE': 'Sie haben die Hauptsprache nicht ausgewählt',
                'POST': 'Sie haben die Sprache ausgewählt:'
              },
              'MODAL': {
                'TITULO': 'Wählen Sie die Hauptsprache',
                'ACCION': 'Welche Sprache ist die Hauptsprache der Umfrage?',
                'PLACELISTA': 'Wählen Sie eine Sprache',
                'BOTONES': {
                  'BACK': 'Zurück',
                  'OK': 'Fertig'
                }
              }
            },
            'CARD2': {
                      'TITULO': 'Zusätzliche Sprachen',
                      'ACCION': {
                        'PRE': 'Sie haben keine zusätzlichen Sprachen ausgewählt',
                        'SINADIC': 'Die Umfrage wird keine zusätzlichen Sprachen haben',
                        'POST': 'Sie haben die folgenden Sprachen ausgewählt:'
                      },
                      'MODAL': {
                        'TITULO': 'Wählen Sie zusätzliche Sprachen',
                        'ACCION': 'Welche Sprachen möchten Sie der Umfrage hinzufügen?',
                        'BOTONES': {
                          'ZURÜCK': 'Zurück',
                          'OK': 'Fertig'
                        }
                      }
                    }
                  },
      'NPS': {
        'CONFIGURE_QUESTION': 'Drücken Sie hier, um den NPS anzuzeigen',
        'ADD': 'Erstellen Sie eine Anweisung',
        'QUESTIONUPDATEDOK': 'NPS erfolgreich aktualisiert',
        'STATUS': {
          'PEND': 'Schritt abschließen',
          'DONE': 'Schritt abgeschlossen',
          'LOCK':'Schritt wieder öffnen',
          'UNLOCK':'Schritt in Bearbeitung'
        },
        'TABS': {
          'TAB1': 'NPS',
          'TAB2': 'Übersetzung',
          'TAB3': 'Vorschau',
        }
      },
      'REACTIVOS': {
        'CONFIGURE_QUESTION': 'Drücken Sie hier, um das Reagenz anzuzeigen',
        'ADD': 'Erstellen Sie eine Anweisung',
        'QUESTIONUPDATEDOK': 'Anweisung erfolgreich aktualisiert',
        'STATUS': {
          'PEND': 'Schritt abgeschlossen',
          'DONE': 'Schritt abgeschlossen',
          'LOCK':'Schritt wieder öffnen',
          'UNLOCK':'Schritt in Bearbeitung'
        },
        'TABS': {
          'TAB1': 'Anweisungen',
          'TAB2': 'Übersetzung',
          'TAB3': 'Vorschau',
        }
      },
      'CONTROL': {
        'CONFIGURE_QUESTION': 'Klicken Sie hier, um die Kontrollfrage anzuzeigen',
        'ADD': 'Erstellen Sie eine Anweisung',
        'QUESTIONUPDATEDOK': 'Kontrollfrage erfolgreich aktualisiert',
        'STATUS': {
          'PEND': 'Schritt abgeschlossen',

          'DONE': 'Schritt abgeschlossen',
          'LOCK':'Schritt wieder öffnen',
          'UNLOCK':'Schritt in Bearbeitung'
        },
        'TABS': {
          'TAB1': 'Kontrollfrage',
          'TAB2': 'Übersetzung',
          'TAB3': 'Vorschau',
        }
      },
      'DEMOGRAFICOS': {
        'NOINFO':'Keine Informationen verfügbar',
        'TAB1': 'Demographisch',
        'TAB2': 'Übersetzung',
        'TAB3': 'Vorschau',
        'COMPLETAR_PASO': 'Schritt abschließen',
        'PASO_COMPLETADO': 'Schritt abgeschlossen',
        'SELECT': 'Eine Option auswählen',
        'BTN_DEMOGRAFICOS': 'Akzeptieren',
        'OPTION_SURVEY': 'Umfrage',
        'OPTION_EXCEL': 'Excel',
        'OPTION_AMBOS': 'Beides',
        'CLAVE': 'Rowkey',
        'RESPONSE_NOT_ADDED': 'Sie können keine Antworten zu einer offenen Frage hinzufügen',
        'CONFIGURE_QUESTION': 'Klicken Sie hier, um die Frage anzuzeigen',
        'QUESTION': 'Frage',
        'OPCIONES_RESPUESTA': 'Antwortmöglichkeiten',
        'STATUS': {
          'PEND': 'Schritt abgeschlossen',
          'DONE': 'Schritt abgeschlossen',
          'LOCK':'Schritt wieder öffnen',
          'UNLOCK':'Schritt in Bearbeitung'
        },
        'EXPANSION':{
          'Work Responsability' : 'Arbeitsverantwortung',
          'Trust Level' : 'Vertrauensniveau',
          'Innovation' : 'Innovation',
          'Disabilities' : 'Behinderungen',
          'Ethnic Group' : 'Ethnische Gruppe',
          'Personal Responsabilities' : 'Persönliche Verantwortlichkeiten',
          'Gender' : 'Geschlecht',
          'Work Location' : 'Arbeitsort',
          'Travel' : 'Reisen',
          'Living Location' : 'Lebensort',
          'Marital Status' : 'Heiratsstatus',
                    'Home Type' : 'Wohnungstyp',
                    'Home Location' : 'Heimatort',
                    'Home Status' : 'Heimatstatus',
                    'Transport' : 'Transport',
                    'Sport' : 'Sport',
                    'Weight' : 'Gewicht',
                    'Sleep' : 'Schlaf',
                    'Home Office' : 'Heimbüro',
                    'Languages' : 'Sprachen',
                    'Work Experience' : 'Berufserfahrung',
                    'Social Networks' : 'Soziale Netzwerke',
                    'Employ Opportunities' : 'Beschäftigungsmöglichkeiten',
                    'Inspiration' : 'Inspiration',
                    'Meetings' : 'Meetings',
                    'Tenure' : 'Festanstellung',
                    'Clave': 'Rowkey',
                    'Ege': 'Ege',
                    'Work Status': 'Arbeitsstatus',
                    'Education': 'Bildung',
                    'Hierarchical Level': 'Hierarchische Ebene',
                    'Confidence Decisions': 'Confidence Decisions',
                    'Work Innovation': 'Arbeitsinnovation',
                    'Belong': 'Zugehörigkeit',
                    'Converse Performance': 'Konversionsleistung',
                    'Work Years': 'Arbeitsjahre',
                    'Generation': 'Generation',
                    'Confidence In Decisions': 'Vertrauen in Entscheidungen',
                    'Develop New Things': 'Neue Dinge entwickeln',
                    'Reason To Stay':'Grund zum Bleiben',
                    'Age':'Alter',
                    'Type Of Job':'Art der Tätigkeit',
                    'Minoritate':'Minoritate',
                    'Sindicat':'Sindicat',
          //TURQUIA//
          'Confidence':'Zuversicht',
          'Opportunities':'Chancen',
          'Managerial Level':'Managerial Level',
          'Years Of Service':'Dienstjahre',
          'Ethnic':'Ethnisch',
          //CAYC//
          'Hierarchical Leve':'Hierarchische Ebene',
          'Disability':'Behinderung',
          'Responsibility':'Verantwortung',
          'LGBT':'LGBT',

          //BRASIL
          'Permanência':'Permanenz',
          'Reuniões':'Meetings',
          'Motivo para ficar':'Grund zum Bleiben',
          'Casa':'Haus',
          'Nível de confiança':'Vertrauensniveau',
          'Oportunidades':'Gelegenheiten',

          //ESPAÑA
          'Recommendation':'Empfehlung',
          'Seniority':'Dienstalter',
          'Contracting modality':'Vertragsmodalität',
          'Working':'Arbeiten',

          //GCTI
          'Pregunta 1': 'Frage 1',
          'Pregunta 2': 'Frage 2',
          'Pregunta 3': 'Frage 3',
          'Pregunta 4': 'Frage 4',
          'Pregunta 5': 'Frage 5',
          'Pregunta 6': 'Frage 6',
          'Pregunta 7': 'Frage 7',
          'Pregunta 8': 'Frage 8',
          'Pregunta 9': 'Frage 9',
          'Pregunta 10': 'Frage 10',
          'Pregunta 11': 'Frage 11',
          'Pregunta 12': 'Frage 12',
          'Pregunta 13': 'Frage 13',
          'Pregunta 14': 'Frage 14',
          'Pregunta 15': 'Frage 15',
        }
      },
      'FORALL': {
        'MSJ_PRACTICEREGISTERED': 'Practice saved succesfully',
                'MSJ_DESCRIPTIONREGISTERED': 'Description saved succesfully',
                'MSJ_TRANSLATEREGISTERED': 'Praxis erfolgreich übersetzt',
                'MSJ_DESCRIPTIONTRANSLATED': 'Beschreibung erfolgreich übersetzt',
                'QUESTIONUPDATEDOK': 'Frage erfolgreich aktualisiert',
                'QUESTIONUPDATEDFAIL': 'Fehler, fügen Sie eine gültige Frage ein',
                'RESPONSEUPDATEDOK': 'Antwort erfolgreich aktualisiert.',
              ' RESPONSEUPDATEDFAIL': 'Fehler, füge einen gültigen Antworttext ein',
                'TRANSLATEDOK': 'Frageübersetzung erfolgreich gespeichert',
                'INSERTTRANSLATE': 'Bitte, fügen Sie den Translate ein',
                'OPTIONTRANSLATED': 'Option translate succesfully gespeichert',
                'INSERTOPTIONTRANSLATE': 'Bitte, fügen Sie den Translate ein',
                'MJS_SELECTOPTION': 'Bitte wählen Sie eine Option aus',
                'MJS_OPTIONADDED': 'Demografie korrekt hinzugefügt',
                'OPTIONDELETED': 'Demografisch erfolgreich gelöscht',
                'RESPONSEOPTIONDELETED': 'Antwort erfolgreich gelöscht',
                'DEMOGRAPHICEXIST': 'Die ausgewählte Bevölkerungsgruppe existiert bereits',
                'AGREGADEMOGRAFICO': 'Auswählen, um weitere demografische Daten hinzuzufügen',
                'MSJ_PRACTICEREQUIRED': 'Übung ist erforderlich!',
                'MSJ_DESCRIPTIONREQUIRED': 'Beschreibung ist erforderlich!',
                'CARGANDO_PRACTICA': 'Praxis wird gespeichert, bitte warten...',
                'CARGANDO_DESCRIPCION': 'Beschreibung wird gespeichert, bitte warten...',
                'ACTUALIZAR_OPCION': 'Antwort aktualisieren, bitte warten...',
                'REVISANDO_PRACTICAS': 'Praktiken überprüfen, bitte warten...',


                'SELECCIONE': 'Wählen Sie eine Sprache, um die Vorschau anzuzeigen',
                'IDIOMAS_NOT_SELECTED': 'Es sind keine weiteren Sprachen zur Übersetzung ausgewählt.',
                'TRANSLATE_NOT': 'Sie müssen mindestens den Namen einer Praxis und deren Beschreibung schreiben',
                'PLACEHOLDER': 'Sprache',
                'DESC_TRANSLATE': 'Beschreibung übersetzen lassen',
                'DESC_TRANSLATE_DEMO': 'Geben Sie die Übersetzung der Antwort ein',
                'DESC_TRANSLATE_FORALL': 'Geben Sie die Übersetzung der Beschreibung ein',
                'PRACTICE_TRANSLATE_REACTIVOS': 'Geben Sie die Übersetzung der Anweisungen ein',
                'PRACTIC_TRANSLATE_ABIERTAS': 'Geben Sie die Übersetzung der offenen Frage ein',
                'PRACTICE_TRANSLATE_FORALL': 'Geben Sie die Praxisübersetzung ein',
                'PRACTIC_TRANSLATE_DEMO': 'Geben Sie die Übersetzung der Demografie ein',
        'IDIOMAS': {
          'Native': 'Einheimisch',
          'es': 'Spanisch',
          'zh1': 'Traditionelles Chinesisch',
          'zh2': 'Vereinfachtes Chinesisch',
          'pt': 'Portugiesisch',
          'en': 'Englisch',
          'vi': 'Vietnamesisch'
        },
        'RESPUESTAS': {
          'Native': 'Nativo',
          'es':{'si': 'Sí',
          'no':'No',
          'casifalso':'Casi siempre es falso',
          'false': 'Frecuentemente es falso',
          'avecesfalse': 'A veces es falso / A veces es verdad',
          'casiverdad': 'Frecuentemente es verdad',
          'verdad': 'Casi siempre es verdad'},
          'zh1':{'si': '有','no':'沒有',
          'casifalso':'從來不是這樣',
          'false': '經常不是這樣',
          'avecesfalse': '有時是有時不是',
          'casiverdad': '經常是這樣',
          'verdad': '總是這樣'},
          'zh2':{'si': '有','no':'没有',
          'casifalso':'从来不是这样',
          'false': '经常不是这样',
          'avecesfalse': '有时是有时不是',
          'casiverdad': '经常是这样',
          'verdad': '总是这样'},
          'pt':{'si': 'Si','no':'não',
          'casifalso':'Casi siempre es falso',
          'false': 'Freqüentemente é falso',
          'avecesfalse': 'A veces es falso / A veces es verdad',
          'casiverdad': 'Freqüentemente es verdad',
          'verdad': 'Casi siempre es verdad'},
          'en':{'si': 'Yes','no':'No',
          'casifalso':'Almost always untrue',
          'false': 'Often untrue',
          'avecesfalse': 'Sometimes untrue/ sometimes true',
          'casiverdad': 'Often true',
          'verdad': 'Almost always true'},
          'tr':{'si': 'Evet','no':'HAYIR',
          'casifalso':'Neredeyse her zaman yanlış',
          'false': 'Sık sık yanlış',
          'avecesfalse': 'Bazen doğru olmayan / bazen doğru',
          'casiverdad': 'Genellikle doğru',
          'verdad': 'Neredeyse her zaman doğru'},
          'jp':{'si': 'はい','no':'番号',
          'casifalso':'ほとんど常に当てはまらない',
          'false': 'しばしば当てはまらない',
          'avecesfalse': '時には当てはまらない／時には当てはまる',
          'casiverdad': 'しばしば当てはまる',
          'verdad': 'ほとんど常に当てはまる'},

          'vi':{'si': 'Đúng','no':'Không',
          'casifalso':'Nó gần như luôn luôn là sai',
          'false': 'Nó thường sai',
          'avecesfalse': 'Đôi khi nó là hàng giả / Đôi khi nó đúng',
          'casiverdad': 'Nó thường đúng',
          'verdad': 'Nó gần như luôn luôn đúng'}
        },
        'STATUS': {
          'PEND': 'Schritt abschließen',
          'DONE': 'Schritt beendet',
          'LOCK':'Schritt wieder öffnen',
          'UNLOCK':'Schritt in Bearbeitung',
        },
        'TABLA': {
          'TITULOS': {
            'DEFAULT': 'Hauptsprache',
            'TRADUCCION': 'Übersetzungen',
            'PREVIEW': 'Vorschau'
          },
          'ENCABEZADOS': {
            'PRACT': 'Praxisname',
            'DESCR': 'Beschreibung',
            'STT1': 'Anweisung 1',
            'STT2': 'Anweisung 2',
            'LANG': 'Sprache'
          },
          'INPUTS': {
            'PRACT': 'Geben Sie den Praxisnamen ein',
            'DESCR': 'Geben Sie den Beschreibungstext ein',
          }
        }
      },
      'ABIERTAS': {
        'STATUS': {
          'PEND': 'Schritt abschließen',
          'DONE': 'Schritt beendet',
          'LOCK':'Schritt wieder öffnen',
          'UNLOCK':'Schritt in Bearbeitung'
        },
        'TABS': {
          'TAB1': 'Offene Fragen',
          'TAB2': 'Übersetzung',
          'TAB3': 'Vorschau',
        }
      },
      'ADICIONALES': {
        'FOCUS':{
          'ENVIO-AUTORIZACION':'Zur Autorisierung gesendet',
          'AUTORIZACION-OK':'Ihre Umfrage wurde autorisiert, fahren Sie fort, den Schritt abzuschließen'

        },
        'STATUS': {
          'PEND': 'Schritt abschließen',
          'DONE': 'Schritt beendet',
          'LOCK':'Schritt wieder öffnen',
          'UNLOCK':'Schritt in Bearbeitung'
        },
        'TABS': {
          'QUESTIONS': 'Zusätzliche Fragen',
          'TRANSLATE': 'Übersetzung',
          'PREVIEW': 'Vorschau'
        },
        'PREGUNTAS':{
          'STATUS': {
            'SIN': 'Sie haben keine zusätzlichen Fragen erstellt',
            'CON': 'Fragen erstellt:',
            'NOADICIONALES': 'Sie haben sich entschieden, keine zusätzlichen Fragen zu erstellen',
            'CANCELNOADIC': 'Sie haben die Option, keine weiteren Fragen zu erstellen, abgebrochen',
            'ERROR': 'Beim Ausführen des Vorgangs ist ein Fehler aufgetreten'
          },
          'ACCIONES': {
            'ADD': 'Eine Frage erstellen',
            'SIN': 'Die Umfrage wird keine zusätzlichen Fragen haben',
          },
          'WIZARD': {
            'NEW': 'Neue Frage',
            'TIPOTITU': 'Klicken Sie hier, um die Zusatzfrage zu konfigurieren',
            'TIPO': {
              'OPEN': 'Offene Frage',
              'UNI': 'Einzelne Optionsfrage',
              'MULT': 'Mehrfach-Optionsfrage',
              'MULTLIKERT3-1': 'Frage auf 3er-Likert-Skala',
              'MULTLIKERT5-1': 'Frage auf 5er-Likert-Skala',
              'TITULOLIKERTSIMPLE': 'Frage auf einer Likert-Skala',
              'MULTLIKERT-MUL': 'Frage auf der Likert-Skala Multiple',

            },
            'FORM': {
              'TIPO': 'Typ der Frage',
              'TOOLTIP': {
                'REMOVE': 'Diese Frage entfernen'
              },
              'MENSAJES': {
                'BORRAR': 'Möchten Sie diese Zusatzfrage löschen?',
                'PREG_OK': 'Die Frage wurde erfolgreich gespeichert',
                'PREG_ERR': 'Beim Speichern der Frage ist ein Fehler aufgetreten',
                'PREG_MOD_OK': 'Die Frage wurde korrekt geändert',
                'PREG_MOD_ERR': 'Beim Ändern der Frage ist ein Fehler aufgetreten',
                'OPC_OK': 'Die Antwortoption wurde erfolgreich gespeichert',
                'OPC_ERR': 'Beim Speichern der Antwortoption ist ein Fehler aufgetreten',
                'OPC_MOD_OK': 'Die Antwortoption wurde korrekt geändert',
                'OPC_MOD_ERR': 'Beim Modifizieren der Antwortoption ist ein Fehler aufgetreten',
                'PREG_DEL_OK': 'Die Frage wurde erfolgreich gelöscht',
                'PREG_DEL_ERR': 'Beim Löschen der Frage ist ein Fehler aufgetreten',
                'OPC_DEL_OK': 'Die Antwortoption wurde erfolgreich gelöscht',
                'OPC_DEL_ERR': 'Beim Löschen der Antwortoption ist ein Fehler aufgetreten',
              },
              'BOTONES':{
                'SI': 'Ja',
                'NO': 'Nein'
              }
            },
            'ABIERTA': {
              'TITULO': 'Neue offene Frage',
              'ACCION': 'Geben Sie den Fragentext ein',
              'ERROR': 'Sie haben den Fragentext nicht eingegeben',
            },
            'MULTI':{
              'TITULOSING': 'Neue Einzeloptionsfrage',
              'TITULOMULT': 'Neue Mehrfach-Optionsfrage',
              'TITULOLIKERT3': 'Neue Frage in Likert-Skala: 3',
              'TITULOLIKERT5': 'Neue Frage auf der Likert-Skala: 5',
              'TITULOLIKERTSIMPLE': 'Neue einfache Frage in Likert-Skala',
              'ACCION': 'Geben Sie den Fragentext ein',
              'ERROR': 'Sie haben den Fragentext nicht eingegeben',
              'MENSAJES': {
                'BORRAR': 'Möchten Sie diese Antwortoption löschen?',
                'SINPREG': 'Sie können keine Option eingeben, bis Sie den Fragentext eingegeben haben',
                'SINANTE': 'Sie können diesen Antwortoptionstext erst eingeben, wenn Sie den vorherigen Antwortoptionstext eingegeben haben',
                'WARN-2-1': 'Sie können nur 2 Antwortmöglichkeiten eingeben',
                'WARN-3-1': 'Sie können nur 3 Antwortmöglichkeiten eingeben',
                'WARN-5-1': 'Sie können nur 5 Antwortmöglichkeiten eingeben',
                'WARN-NO-NUMBER': 'Sie können nur Zahlen eingeben',
                'ETIQUET-VALOR': 'Wert',
              },
              'OPCIONES': {
                'TITU': 'Antwortoptionen',
                'INPUT': {
                  'TITU': 'Antwortoption',
                  'ERROR': 'Sie haben den Text für die Antwortoption nicht eingegeben',
                }
              },
              'TOOLTIP': {
                'ADD': 'Eine Antwortoption hinzufügen',
                'MOVE': 'Antwortoption verschieben',
                'REMOVE': 'Diese Antwortoption entfernen'
              }
            }
          }
        },
        'TRADUCCIONES': {
          'TITULO': 'Wählen Sie eine Sprache, um mit der Eingabe der Übersetzungstexte zu beginnen',
          'TITULOALTERNO': 'Sie haben im Bereich "Sprachen" keine zusätzliche Sprache ausgewählt',
          'NOTYET': 'Die Übersetzung ist noch nicht abgeschlossen',
          'MAIN': 'Hauptsprache',
          'INPUT': {
            'NEW': 'Geben Sie die Frageübersetzung ein',
            'ERROR': 'Sie haben die Frageübersetzung nicht eingegeben!',
            'NEWOPC': 'Geben Sie die Übersetzung der Antwortmöglichkeit ein',
            'ERROROPC': 'Sie haben die Übersetzung der Antwortoption nicht eingegeben!'
          },
          'MENSAJES': {
            'PREG_OK': 'Der Übersetzungstext wurde erfolgreich gespeichert',
            'PREG_ERR': 'Beim Speichern des Übersetzungstextes ist ein Fehler aufgetreten',
            'PREG_MOD_OK': 'Der Übersetzungstext wurde korrekt aktualisiert',
            'PREG_MOD_ERR': 'Beim Aktualisieren des Übersetzungstextes ist ein Fehler aufgetreten',
            'OPC_NOPREG': 'Der Übersetzungstext für diese Option kann erst gespeichert werden, wenn der Fragentext gesetzt ist',
            'OPC_OK': 'Der Übersetzungstext wurde erfolgreich gespeichert',
            'OPC_ERR': 'Beim Speichern des Übersetzungstextes ist ein Fehler aufgetreten',
            'OPC_MOD_OK': 'Der Übersetzungstext wurde korrekt aktualisiert',
            'OPC_MOD_ERR': 'Beim Aktualisieren des Übersetzungstextes ist ein Fehler aufgetreten',
            'TRADUC_PREGUNT':'Die Übersetzung der Frage wird gespeichert...',
            'TRADUC_MOD_PREGUNT':'Die Übersetzung der Frage wird aktualisiert...',
            'TRADUC_OPC':'Die Übersetzung der Option wird gespeichert...',
            'TRADUC_MOD_OPC':'Die Übersetzung der Option wird aktualisiert...',
            'VALOR_OK':'Der Wert der Option wird korrekt gespeichert',
            'VALOR_MOD_OK':'Der Wert der Option wurde korrekt aktualisiert',
          },
          'COMPLETE': 'Übersetzung komplett '
        },
        'PREVIEW': {
          'TITULO': 'Wählen Sie eine Sprache, um die Übersetzungen der Zusatzfragen anzuzeigen',
          'SINPREV': 'Es gibt keine übersetzten Texte für die ausgewählte Sprache',
          'LOADING': 'Daten werden geladen',
          'INPUT': {
            'RESPABIERTA': 'Schreiben Sie Ihre Antwort',
            'ERRORABIERTA': 'Sie haben Ihre Antwort nicht geschrieben!',
            'ELIGELANG': 'Wählen Sie eine Sprache',
          },
          'HELP': {
            'SINGLE': 'Sie können nur eine Option in dieser Frage wählen',
            'MULTI': 'Sie können bei dieser Frage mehr als eine Option wählen',
            'FALTA': 'Der Übersetzungstext wurde nicht eingegeben!'
          }
        }
      },
      'COLABORADORES': {
        'STATUS': {
          'PEND': 'Schritt abschließen',
          'DONE': 'Schritt beendet',
          'LOCK':'Schritt wieder öffnen',
          'UNLOCK':'Schritt in Bearbeitung',
        },
        'STATUSBAR': {
          'NOBD': 'Sie haben Ihre Teilnehmerdatenbank nicht geladen',
          'PROCES': 'Die Teilnehmerdatenbank ist noch nicht gespeichert',
          'ERROR': 'In der geladenen Datei wurden Fehler gefunden',
          'OK': 'Die Teilnehmerdatenbank ist korrekt gespeichert'
        },
        'CARD_BD': {
          'TITULO': 'Information',
          'NUMCOLABS': 'Anzahl der Teilnehmer',
          'FECHA': 'Letztes Upload-Datum:',
          'TITULO_PRE': 'Upload-Historie:',
          'TITULO_PRE_2': 'Benutzer',
          'ACCIONES': 'Aktionen',
          'WANNADO': 'Was wollen Sie tun?',
          'BOTONES': {
            'DESCARGA': 'Herunterladen der Teilnehmerdatenbank',
            'ELIMINA': 'Löschen der Teilnehmerdatenbank',
            'VER': 'Siehe Teilnehmerliste'
          }
        },
        'CARD_NOBD': {
          'TITULO': 'Folgen Sie diesen Schritten, um Ihre Teilnehmerinformationen in Cultural GO® hochzuladen',
          'PASOS': {
            '1': 'Laden Sie die Teilnehmerdatenbank-Vorlage herunter',
            '2': 'Füllen Sie die Vorlage mit Ihren Teilnehmerinformationen basierend auf den bereitgestellten Spalten',
            '3': 'Laden Sie die Datei mit Ihren Teilnehmerinformationen hoch',
          },
          'TOOLTIP': 'Diese Datei enthält Makros zur Datenüberprüfung',
          'FILE': 'Collaborators List Template file'
        },
        'CARD_NOERR': {
          'TITULO': 'Information',
          'NUMCOLABS': 'Anzahl der Teilnehmer in der geladenen Datei',
          'FILENAME': 'Name der Datei',
          'GUARDAR': 'Wollen Sie diese Information speichern?',
          'BOTONES': {
            'SI': 'Ja',
            'NO': 'Nein'
          }
        },
        'CARD_ERRFND': {
          'TITULO': 'Information',
          'ROWS_OK': 'Anzahl der richtigen Zeilen',
          'ROWS_NOTOK': 'Anzahl der Zeilen mit Fehlern',
          'MOREINFO': '* Die Fehlerliste im Detail wird unten angezeigt',
          'FILENAME': 'Name der Datei',
          'GUARDAR': 'Die geladenen Informationen können nicht gespeichert werden',
          'DELETE': 'Datei löschen'
        },
        'CARD_ERRLIST': {
          'TITULO': {
            '1': 'Zeilen mit Fehlern: ',
            '2': 'Insgesamt gefundene Fehler:'
          },
          'INFO': {
            'ROW': 'Zeile',
            'ERRNUM': 'Anzahl der Fehler: ',
            'SHOW': 'Klicken Sie hier, um die Fehler dieser Zeile anzuzeigen'
          },
          'DETALLE': {
            'TIPO': 'Art des Fehlers',
            'DESCR': 'Beschreibung',
            'COLUMNA': 'Spalte',
            'DATO': 'Falsche Daten'
          },
          'ERRORES': {
            'alfabetica': 'Alphabetische ungültige Daten',
            'alfanumerica': 'Alphanumerische ungültige Daten',
            'numerica': 'Numerische ungültige Daten',
            'email': 'E-Mail ungültige Syntax',
            'vacio': 'Leere Zelle',
            'columna': 'Unbekannte Spalte',
            'catSurvey': 'Unbekannte Daten',
            'repetido': 'Wiederholte Daten',
            'sameKey': 'Derselbe Chef-Schlüssel',
            'noCeo': 'Chef nicht gefunden',
            'bosskeyNotFnd': 'Chef-Schlüssel nicht gefunden',
            'continuidad': 'Kontinuität in Stufen',
            'nivelRepetido': 'Wiederholte Informationen',
            'multiceo': 'Mehrere CEOs',
            'age': 'Falsches Geburtsjahr',
            'seccionSinUsar': 'Sonderabschnittsschlüssel nicht verwendet',
            'date': 'ungültiges Datumsformat',
            'listOption': 'Falsche Angaben',
            'dateFuture': 'Datum nicht erlaubt',
            'longitud_60': 'Anzahl der zulässigen Zeichen überschritten'
          },
          'DESCRIPCION': {
            'alfabetica': 'Die Information hat ein oder mehrere ungültige Zeichen. Nur alphabetische Zeichen (A - Z) und die folgenden Sonderzeichen: [( ) . , : -] sind erlaubt ',
            'alfanumerica': 'Die Information hat ein oder mehrere ungültige Zeichen. Nur alphabetische Zeichen (A - Z), numerische Zeichen (0 - 9) und die nächsten Sonderzeichen: [( ) . , : -] sind erlaubt ',
            'numerica': 'Die Information hat ein oder mehrere ungültige Zeichen. Nur numerische Zeichen (0 - 9) sind erlaubt',
            'email': 'Die Information hat nicht die richtige E-Mail-Syntax ( mail@domain.com )',
            'vacio': 'Die Zelle enthält keine Informationen. Diese Spalte ist obligatorisch.',
            'columna': 'Die Spalte gehört nicht zu der von CULTURAL GO® bereitgestellten Vorlage',
            'catSurvey': 'Die Zelleninformation stimmt mit keiner Option überein, die im Abschnitt "Demografie" der Plattform eingegeben wurde',
            'repetido': 'Diese Zelle enthält wiederholte Informationen aus einer anderen Zelle in derselben Spalte. Wiederholte Daten sind in dieser Spalte nicht erlaubt.',
            'sameKey': 'Diese Zeile hat die gleiche Information in dieser Spalte: \'MITARBEITERNUMMER\' und \'DIREKTER VORSITZENDERNUMMER\', dies ist nicht zulässig.',
            'noCeo': 'Die CEO-Information wurde in der Mitarbeiterliste nicht gefunden, sie muss mit der BESCHÄFTIGTENNUMMER als \'0\' angegeben werden, um fortzufahren',
            'bosskeyNotFnd': 'Der in dieser Zelle angegebene Schlüssel des Chefs wurde nicht in Verbindung mit einem Mitarbeiter in der Liste gefunden',
            'continuidad': 'Die Kontinuität der Ebenen in dieser Zelle wurde unterbrochen, die Ebenen müssen kontinuierlich sein',
            'nivelRepetido': 'Die Information in dieser Zelle wurde mit derjenigen wiederholt, die der vorherigen Ebene entspricht, dies ist nicht zulässig',
            'multiceo': 'Es wurde mehr als ein als CEO angegebener Mitarbeiter gefunden, es darf nur ein Mitarbeiter als CEO in der Datei angegeben sein ',
            'age': 'Das eingegebene Geburtsjahr muss vierstellig sein',
            'seccionSinUsar': 'Es wurde mindestens ein spezieller Abschnittsschlüssel gefunden, der in der Liste der Mitbearbeiter nicht verwendet wurde. Alle Sonderabschnittsschlüssel müssen von mindestens einem Mitarbeiter verwendet werden',
            'date': 'Die eingegebenen Informationen haben nicht das richtige Datumsformat',
            'listOption': 'Die eingegebenen Informationen stimmen mit keiner der Optionen der Vorlage überein. In dieser Zelle ist nur eine der Standardoptionen zulässig',
            'dateFuture': 'Das in die Zelle eingegebene Datum entspricht einem Datum nach dem aktuellen Tag. Es darf nur ein Datum vor dem aktuellen Tag eingegeben werden',
            'longitud_60': 'Die Informationen überschreiten die maximal zulässige Anzahl von Zeichen für diese Spalte (60 Zeichen).'
          }
        },
        'CARD_LOAD': {
          'CARGA': {
            'TITULO': 'Laden',
            'INFO': 'Analysieren der Dateiinformationen, bitte warten Sie einen Moment',
          },
          'GUARDA': {
            'TITULO': 'Speichern',
            'INFO': 'Speichern der Informationen ins System, bleiben Sie in dieser Maske, bis der Speichervorgang beendet ist',
          },
        },
        'MENSAJES': {
          'GUARDA_1': 'Bestätigen Sie die Speicherung der Informationen von ',
          'GUARDA_2': 'Teilnehmer?',
          'GUARDADO': 'Die Teilnehmerdatenbank wurde erfolgreich gespeichert',
          'GUA_ERR': 'Beim Speichern der Informationen ist ein Fehler aufgetreten. Versuchen Sie es später erneut',
          'NODELETE':'Die Datenbank kann nicht gelöscht werden, wenn die E-Mails an die Mitarbeiter gesendet wurden',
          'DELETE_1':'Bestätigen Sie das Löschen der Informationen von ',
          'DELETE_2': 'Mitarbeiter?',
          'DEL_OK_1': 'Die Informationen von ',
          'DEL_OK_2': 'Mitarbeiter wurden erfolgreich gelöscht',
          'DEL_ERR': 'Beim Löschen der Collaborators-Datenbank ist ein Fehler aufgetreten. Versuchen Sie es später erneut',
          'DEL_ERR_EMA_SEN': 'Diese Aktion ist nicht möglich, da die E-Mails bereits gesendet wurden',
          'DELFILE': 'Die Teilnehmerdatenbankdatei wurde korrekt entfernt',
          'EXCEL': 'Excel-Datei wird erzeugt, bitte warten Sie einen Moment',
          'EXTMAL': 'Die ausgewählte Datei hat nicht die richtige Erweiterung. Es darf nur die von CULTURAL GO® bereitgestellte Vorlagendatei hochgeladen werden',
          'NOROWS': 'Die ausgewählte Datei hat keinen Datensatz',
          'VACIO': 'Die ausgewählte Datei ist leer, oder die Informationen zu den Mitarbeitern sind nicht im ersten Blatt enthalten',
          'VERSIONANTERIOR': 'Die ausgewählte Datei entspricht einer früheren Version der Liste der Mitarbeiter, laden Sie die neueste Version herunter, laden Sie die Informationen Ihrer Mitarbeiter in dieser Datei hoch und laden Sie die Liste erneut hoch',
          'BROKERINCORRECTO': 'Die ausgewählte Datei entspricht nicht der Version des Brokers, zu dem das Unternehmen gehört, laden Sie die Vorlage erneut herunter, laden Sie die Informationen Ihrer Mitarbeiter in diese Datei hoch und laden Sie die Liste erneut hoch',
          'BOTONES': {
            'SI': 'Ja',
            'NO': 'Nein'
          }
        },
        'EXCELINFO': {
          'HOJA': 'Mitarbeiterdaten',
          'TITULO': 'Mitarbeiter-Datenbank',
          'AUTOR': 'CULTURAL GO®',
          'ASUNTO': 'Heruntergeladen von Plattform'
        },
        'UPLOAD': 'Klicken Sie hier, um die Teilnehmerdatenbank zu durchsuchen',
        'REMOVE': 'Aus dem Upload entfernen',
        'SENDEN': 'An Datenbank senden',
        'PROCESO': {
          'STP1': 'Analysieren der Datenbank der Mitarbeiter',
          'STP2': 'Speichern der Kollaborateur-Datenbank',
        },
        'ALERT_COLAB':'Die Benutzer werden in der Umfrage berücksichtigt, sobald dieser Schritt als abgeschlossen markiert ist',
        'MODAL_ERROR': {
          'TITULO': 'Fehler in der Datei gefunden',
          'TOTAL_ERRORES_1': 'Fehler in der Datei gefunden',
          'TOTAL_ERRORES_2': '<b> mehr als 100 </b> Fehler in der Datei gefunden',
          'INFO_1': 'Die Anzahl und Art der spezifischen Fehler sind unten im Detail dargestellt',
          'INFO_2': '<b> HINWEIS: </b> Der Vorgang kann nur fortgesetzt werden, wenn die Datei keine Fehler enthält. Beim Schließen dieses Fensters wird der Vorgang neu gestartet. Nehmen Sie die erforderlichen Korrekturen an der Datei vor und laden Sie sie erneut',
          'TABLA_RESUMEN': {
            'TIPO': 'Fehlerart',
            'TOTAL': 'Gesamtfehler',
            'ACCIONES': 'Aktionen',
            'MASINFO': 'Mehr Informationen',
            'VERMAS': 'Fehler anzeigen'
          },
          'TABLA_LISTA': {
            'TOTAL_1': 'Angezeigte Fehler',
            'TOTAL_2': 'Fehler werden nicht angezeigt',
            'INFO': 'Nicht gezeigte Fehler haben ähnliche Eigenschaften wie die gezeigten',
            'FILA': 'Reihe',
            'COLUMNA': 'Spalte',
            'DATO': 'Falschen Daten'
          },
          'BOTONES': {
            'REGRESAR': 'Geh zurück',
            'CONTINUAR': 'Weitermachen'
          }
        }
      }
    }
  }
};
